import { sanitizeSlug } from '../../utils/sanitizeSlug';

// eslint-disable-next-line no-underscore-dangle
declare const __PATH_PREFIX__: undefined | string;

export const getWithoutPathPrefix = (value: string): string => {
  // use the global which is set by Gatsby instead of passing it through multiple components
  // __PATH_PREFIX__ is available once the docs are build and not during dev mode
  if (
    value.startsWith('/') &&
    typeof __PATH_PREFIX__ !== `undefined` &&
    __PATH_PREFIX__
  ) {
    return sanitizeSlug(value.replace(new RegExp(__PATH_PREFIX__, 'gi'), ''));
  }

  return sanitizeSlug(value);
};
